import React, { FunctionComponent, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
// import { useAtom } from 'jotai';

// import { loginAtom, renew_sign_in } from '../../lib/auth';

import AttachFileIcon from '@mui/icons-material/AttachFile';
import NotesIcon from '@mui/icons-material/Notes';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import QuizIcon from '@mui/icons-material/Quiz';

import {
  Avatar,
  Badge,
  Box,
  Divider,
  Stack,
  Tooltip,
} from '@mui/material';

import {
  IconButton,
  Typography
} from '../../../../components/v2/styled';
import { AttachmentSimple } from '../../AttachmentSimple';

import { KnowledgeAttachment } from '../../../../models/KnowledgeAttachment';
import { KnowledgeCourse } from '../../../../models/KnowledgeCourse';
import { KnowledgeLesson } from '../../../../models/KnowledgeLesson';
import { KnowledgeSubject } from '../../../../models/KnowledgeSubject';
import { Questionnaire } from '../../../../models/Questionnaire';

import HelpersKnowledge from '../../../../actions/helpers/knowledge';
import HelpersLanguage from '../../../../actions/helpers/language';
import AddCircleOutline from '@mui/icons-material/AddCircleOutline';
import { Add, Edit } from '@mui/icons-material';

// const { DateTime } = require("luxon");

type Props = {
  knowledgeCourse: KnowledgeCourse;
  knowledgeSubject: KnowledgeSubject;
  knowledgeLesson: KnowledgeLesson;
  i: number;
  setLessonEditingId?: (n:number) => void;
  setLessonEditOpen?: (b:boolean) => void;
  setActiveSubject?: (k:KnowledgeSubject) => void;
  mutationDestroy?: any;
  setCurrentAttachment?: (a:KnowledgeAttachment) => void;
  setAttachmentOpen?: (b:boolean) => void;
  questionnaire?: Questionnaire;
};

export const StyledKnowledgeLessonContent: FunctionComponent<Props> = ({questionnaire, setCurrentAttachment, setAttachmentOpen, knowledgeCourse, knowledgeSubject, knowledgeLesson, setActiveSubject, i, setLessonEditingId, setLessonEditOpen, mutationDestroy}) => {
  // const [login, setLogin] = useAtom(loginAtom);
  const theme = useTheme();
  const {t, i18n} = useTranslation(['translations']);

  const [clickedOpen, setClickedOpen] = useState<string>();

  return (<Box sx={{
    padding: 1,
    border: '1px solid transparent',
    borderColor: theme.palette.primary.main,
    borderRadius: 1,
    position: 'relative',
    paddingLeft: 10,
    paddingRight: 2,
  }}>
    <Tooltip title={t("coach.submenu.knowledge_attachment.lesson_content_titles.content")}><Avatar sx={{position: 'absolute', top: 8, left: 8, backgroundColor: Object.values(knowledgeLesson.full_body || {}).filter(fff => !!fff).length > 0 ? theme.palette.tertiary?.main : theme.palette.secondary.main}}>
      <NotesIcon />
    </Avatar></Tooltip>
    <Stack direction="row" spacing={2}>
      {(knowledgeCourse.access_data?.availability || [1]).map(mmm => HelpersLanguage.mapping_to_iso(mmm)).map(locale => <Box sx={{
        position: 'relative'
      }}>
        {!(knowledgeLesson.full_body || {})[HelpersLanguage.mapping_to_id(locale)] && <Add sx={{position: 'absolute', top: -4, right: -4, color: 'rgba(0, 0, 0, 0.54)', fontSize: '18px', zIndex: 1201}} />}
        {!!(knowledgeLesson.full_body || {})[HelpersLanguage.mapping_to_id(locale)] && <Edit sx={{position: 'absolute', top: -4, right: -4, color: 'rgba(0, 0, 0, 0.54)', fontSize: '18px', zIndex: 1201}} />}
        <Avatar sx={{
          backgroundColor: !!(knowledgeLesson.full_body || {})[HelpersLanguage.mapping_to_id(locale)] ? theme.palette.primary.main: 'lightgrey',
          cursor: 'pointer',
          zIndex: 1200
        }} onClick={() => {
          if (!!setLessonEditingId) setLessonEditingId(knowledgeLesson.id || 0);
          if (!!setActiveSubject) setActiveSubject(knowledgeSubject);
          if (!!setLessonEditOpen) setLessonEditOpen(true);
        }}>{locale}</Avatar>
      </Box>)}
    </Stack>

    <Divider sx={{marginTop: 1, marginBottom: 1}} />

    <Tooltip title={t("coach.submenu.knowledge_attachment.lesson_content_titles.lesson_video")}><Avatar sx={{position: 'absolute', top: 64, left: 8, backgroundColor: Object.values(knowledgeLesson?.videos || {}).filter(fff => !!fff?.item_file_name).length > 0 ? theme.palette.tertiary?.main : 'lightgrey'}}>
      <OndemandVideoIcon />
    </Avatar></Tooltip>
    <Stack direction="row" spacing={2}>
      {(knowledgeCourse.access_data?.availability || [1]).map(mmm => HelpersLanguage.mapping_to_iso(mmm)).map(locale => <Tooltip title={((knowledgeLesson?.videos || {})[locale] || {}).item_file_name}><Box sx={{
        position: 'relative'
      }}>
        {!((knowledgeLesson?.videos || {})[locale] || {}).item_file_name && <Add sx={{position: 'absolute', top: -4, right: -4, color: 'rgba(0, 0, 0, 0.54)', fontSize: '18px', zIndex: 1201}} />}
        {!!((knowledgeLesson?.videos || {})[locale] || {}).item_file_name && <Edit sx={{position: 'absolute', top: -4, right: -4, color: 'rgba(0, 0, 0, 0.54)', fontSize: '18px', zIndex: 1201}} />}
        <Avatar sx={{
          backgroundColor: !!((knowledgeLesson?.videos || {})[locale] || {}).item_file_name ? theme.palette.primary.main : 'lightgrey',
          cursor: 'pointer'
        }} onClick={() => {
          if (!!setCurrentAttachment) setCurrentAttachment({
            knowledge_course_id: knowledgeCourse?.id,
            knowledge_course: knowledgeCourse,
            knowledge_lesson_id: knowledgeLesson?.id,
            knowledge_lesson: knowledgeLesson,
            is_featured: true,
            locale: locale,
            get_item: ((knowledgeLesson?.videos || {})[locale] || {}).get_item,
            item_file_name: ((knowledgeLesson?.videos || {})[locale] || {}).item_file_name,
            id: ((knowledgeLesson?.videos || {})[locale] || {}).id
          });
          if (!!setAttachmentOpen) setAttachmentOpen(true);
        }}>{locale}</Avatar></Box></Tooltip>)}
    </Stack>

    <Divider sx={{marginTop: 1, marginBottom: 1}} />

    <Tooltip title={t("coach.submenu.knowledge_attachment.lesson_content_titles.lesson_quiz")}><Avatar sx={{
      position: 'absolute', top: 112, left: 8, backgroundColor: !!questionnaire ? theme.palette.tertiary?.main : 'lightgrey'
    }}>
      <QuizIcon />
    </Avatar></Tooltip>
    {!!((questionnaire?.extra_data?.public_name || {})[i18n.resolvedLanguage || 'nl'] || questionnaire?.name) && <Typography variant="h5" sx={{cursor: 'pointer'}} onClick={() => {
      if (!!setLessonEditingId) setLessonEditingId(knowledgeLesson.id || 0);
      if (!!setActiveSubject) setActiveSubject(knowledgeSubject);
      if (!!setLessonEditOpen) setLessonEditOpen(true);
    }}>{(questionnaire?.extra_data?.public_name || {})[i18n.resolvedLanguage || 'nl'] || questionnaire?.name}</Typography>}
    {!((questionnaire?.extra_data?.public_name || {})[i18n.resolvedLanguage || 'nl'] || questionnaire?.name) && <Typography variant="h5" sx={{color: 'lightgrey', cursor: 'pointer', fontStyle:' italic'}} onClick={() => {
      if (!!setLessonEditingId) setLessonEditingId(knowledgeLesson.id || 0);
      if (!!setActiveSubject) setActiveSubject(knowledgeSubject);
      if (!!setLessonEditOpen) setLessonEditOpen(true);
    }}>{t("coach.submenu.knowledge_attachment.add_quiz")}</Typography>}

    <Divider sx={{marginTop: 1, marginBottom: 1}} />

    <Tooltip title={t("coach.submenu.knowledge_attachment.lesson_content_titles.lesson_attachments")}><Avatar sx={{position: 'absolute', top: 160, left: 8, backgroundColor: Object.values(knowledgeLesson.attachments || {}).filter(fff => fff.length > 0).length > 0 ? theme.palette.tertiary?.main : 'lightgrey'}}>
      <AttachFileIcon />
    </Avatar></Tooltip>
    <Stack direction="row" spacing={2}>
      {(knowledgeCourse.access_data?.availability || [1]).map(mmm => HelpersLanguage.mapping_to_iso(mmm)).map(locale => <Badge sx={{
        '& .MuiBadge-badge': {
          right: -3,
          top: 10,
        },
      }} color="secondary" badgeContent={((knowledgeLesson?.attachments || {})[locale] || {}).length}><Box sx={{
        position: 'relative'
      }}>
        {((knowledgeLesson?.attachments || {})[locale] || {}).length < 1 && <Add sx={{position: 'absolute', top: -4, right: -4, color: 'rgba(0, 0, 0, 0.54)', fontSize: '18px', zIndex: 1201}} />}
        <Avatar sx={{
        backgroundColor: ((knowledgeLesson?.attachments || {})[locale] || {}).length > 0 ? theme.palette.primary.main : 'lightgrey',
        cursor: 'pointer',
        ...(!!clickedOpen && clickedOpen !== locale ? {
          opacity: 0.4
        } : {})
      }} onClick={() => {
        if (((knowledgeLesson?.attachments || {})[locale] || {}).length > 0 && clickedOpen !== locale) setClickedOpen(locale);
        if (((knowledgeLesson?.attachments || {})[locale] || {}).length > 0 && clickedOpen === locale) setClickedOpen(undefined);
        if (((knowledgeLesson?.attachments || {})[locale] || {}).length === 0) {
          setClickedOpen(undefined);
          if (!!setCurrentAttachment) setCurrentAttachment({
            knowledge_course_id: knowledgeCourse?.id,
            knowledge_course: knowledgeCourse,
            knowledge_lesson_id: knowledgeLesson?.id,
            knowledge_lesson: knowledgeLesson,
            is_featured: false,
            locale: locale
          });
          if (!!setAttachmentOpen) setAttachmentOpen(true);
        }
      }}>{locale}</Avatar></Box></Badge>)}
    </Stack>

    {!!clickedOpen && <Box sx={{
      paddingTop: 1
    }}>
      <IconButton
        onClick={() => {
          if (!!setCurrentAttachment) setCurrentAttachment({
            knowledge_course_id: knowledgeCourse?.id,
            knowledge_course: knowledgeCourse,
            knowledge_lesson_id: knowledgeLesson?.id,
            knowledge_lesson: knowledgeLesson,
            is_featured: false,
            locale: clickedOpen,
            hide_current: true
          });
          if (!!setAttachmentOpen) setAttachmentOpen(true);
        }}
        sx={{
          marginBottom: 8
        }}
        color='primary'
      >
        <AddCircleOutline sx={{
          width: 80,
          height: 80
        }} />
      </IconButton>
      {((knowledgeLesson?.attachments || {})[clickedOpen] || {}).map((attachment, i) => <AttachmentSimple
        url={attachment.get_item}
        file_name={attachment.item_file_name}
        onClick={() => {
          if (!!setCurrentAttachment) setCurrentAttachment({
            knowledge_course_id: knowledgeCourse?.id,
            knowledge_course: knowledgeCourse,
            knowledge_lesson_id: knowledgeLesson?.id,
            knowledge_lesson: knowledgeLesson,
            is_featured: false,
            locale: clickedOpen,
            item_link: attachment.get_item,
            item_file_name: attachment.item_file_name,
            id: attachment.id,
            hide_current: true
          });
          if (!!setAttachmentOpen) setAttachmentOpen(true);
        }}
      />)}
    </Box>}
  </Box>);
}
